import LayoutSettings from '@/components/LayoutSetting/LayoutSettings';
import { DELIVERY_RESTRICTION_CUSTOM } from '@/constants/enum';
import { deliverySettingSelector, deliveryStateSelector, handleSaveDeliverySettings } from '@/redux/slice/delivery.slice';
import { TextField } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { StyledInputPrefix } from '../../styled';

interface Props {
  unit?: string;
}

const DeliveryZoneRadius = ({ unit }: Props) => {
  const { t } = useTranslation('deliverySettings');
  const dispatch = useDispatch();
  const deliverySettings = useSelector(deliverySettingSelector);
  const deliveryState = useSelector(deliveryStateSelector);

  return (
    <div id="postal-code">
      <LayoutSettings
        title={t('sections.deliveryZoneRadius.title')}
        helpText={t('sections.deliveryZoneRadius.helpText')}
        children={
          <StyledInputPrefix>
            <TextField
              type="number"
              label={t('sections.deliveryZoneRadius.label')}
              value={deliverySettings.deliveryRestrictionRange.toString()}
              onChange={(value) => dispatch(handleSaveDeliverySettings({ deliveryRestrictionRange: Number(value) }))}
              min={0}
              autoComplete="off"
              error={
                deliveryState.isSaving &&
                deliverySettings.isActive &&
                deliverySettings.deliveryRestrictionRange === 0 &&
                t('sections.deliveryZoneRadius.error')
              }
              prefix={unit === DELIVERY_RESTRICTION_CUSTOM.KM ? 'km' : 'mi'}
            />
          </StyledInputPrefix>
        }
      />
    </div>
  );
};

export default DeliveryZoneRadius;
